import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { coolGrey, lightTransparentBlue, borderLightGray } from 'lib/css/colors';
import TagBadge from 'components/shared/TagBadge';

function TagList({ tags = [], maxVisible = 3, editable = false, onEdit }) {
  const hasNoTags = !tags || tags.length === 0;
  const visibleTags = maxVisible && tags ? tags.slice(0, maxVisible) : tags || [];
  const remainingCount = tags ? tags.length - visibleTags.length : 0;

  if (hasNoTags && editable) {
    return (
      <div
        className={css(styles.container, styles.editable)}
        onClick={onEdit}
        title="Click to add tags"
      >
        <span className={css(styles.emptyText)}>No tags</span>
        <FontAwesomeIcon icon={faPencilAlt} className={css(styles.editIcon)} />
      </div>
    );
  }

  if (hasNoTags) {
    return <span className={css(styles.emptyText)}>No tags</span>;
  }

  return (
    <div
      className={css(styles.container, editable && styles.editable)}
      onClick={editable ? onEdit : undefined}
      title={editable ? 'Click to edit tags' : undefined}
    >
      <div className={css(styles.tagsWrapper)}>
        {visibleTags.map((tag, index) => (
          <TagBadge key={`${tag}-${index}`} tag={tag} variant="info" />
        ))}
        {remainingCount > 0 && <span className={css(styles.moreText)}>+{remainingCount} more</span>}
        {editable && <FontAwesomeIcon icon={faPencilAlt} className={css(styles.editIcon)} />}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 24,
    gap: 8,
  },
  tagsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 4,
  },
  editable: {
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: 4,
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: borderLightGray,
    },
  },
  emptyText: {
    color: coolGrey,
    fontSize: 13,
    fontStyle: 'italic',
  },
  moreText: {
    color: coolGrey,
    fontSize: 12,
    fontWeight: 500,
  },
  editIcon: {
    fontSize: 12,
    color: lightTransparentBlue,
    opacity: 0.6,
    marginLeft: 4,
  },
});

TagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  maxVisible: PropTypes.number,
  editable: PropTypes.bool,
  onEdit: PropTypes.func,
};

export default TagList;
